import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { totalStepsSelector } from 'selectors/pathBuilder';
import { TYPES } from 'constants/config';
import { pluralizeWithCount } from 'utils/string_utils';
import invariant from 'utils/invariant';
import PerformanceHeader from './PerformanceHeader';
import ContentPerformanceFigures from './ContentPerformanceFigures';
import Lesson from './Lesson';
import Path from './Path';

const typeToComponent = {
  [TYPES.LESSON]: Lesson,
  [TYPES.PATH]: Path,
};

const renderContent = props => {
  const ContentComponent = typeToComponent[props.type];

  invariant(
    !!ContentComponent,
    `Expected content type to be one of "${Object.keys(typeToComponent)}"` +
      ` but instead received "${props.type}"`,
  );

  return <ContentComponent key={props.id} {...props} />;
};

const ContentsList = ({
  totalLessons,
  totalScore,
  totalComplete,
  contents,
}) => (
  <div>
    <PerformanceHeader />
    <div className="PerformanceContent d-f jc-sb">
      <div className="fz-bigger">
        {totalLessons > 1 && 'All'} {pluralizeWithCount(totalLessons, 'Step')}
      </div>
      <ContentPerformanceFigures score={totalScore} finished={totalComplete} />
    </div>
    {contents
      .filter(content => content.type !== TYPES.WAITSTEP)
      .map(renderContent)}
  </div>
);

const mapStateToProps = ({ pathBuilder }) => ({
  totalLessons: totalStepsSelector(pathBuilder),
  totalScore: get(pathBuilder.reporting, 'performance.score'),
  totalComplete: get(pathBuilder.reporting, 'performance.totalCompleted'),
  contents: pathBuilder.contents,
});

export default connect(mapStateToProps)(ContentsList);
